import React from 'react';
import { NFTData } from '../types';

interface NFTDetailModalProps {
  nft: NFTData | null;
  isOpen: boolean;
  onClose: () => void;
}

const NFTDetailModal: React.FC<NFTDetailModalProps> = ({ nft, isOpen, onClose }) => {
  if (!isOpen || !nft) return null;

  const getImageSrc = () => {
    if (nft.metadata.svg) {
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(nft.metadata.svg)}`;
    }
    if (nft.metadata.image) {
      const img = nft.metadata.image;
      return img.startsWith('ipfs://') 
        ? img.replace('ipfs://', 'https://gateway.pinata.cloud/ipfs/')
        : img;
    }
    return null;
  };

  const imageSrc = getImageSrc();

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        <div className="modal-header">{nft.metadata.name}</div>
        <div className="modal-content">
          <div className="modal-image">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt={nft.metadata.name}
                className="modal-img"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if (fallback) fallback.style.display = 'flex';
                }}
              />
            ) : null}
            <div className="modal-img-fallback" style={{ display: imageSrc ? 'none' : 'flex' }}>
              No Image Available
            </div>
          </div>

          {nft.metadata.description && (
            <div className="section">
              <div className="section-title">Description</div>
              <p className="section-text">{nft.metadata.description}</p>
            </div>
          )}

          {(nft.siteName || nft.siteURL) && (
            <div className="section">
              <div className="section-title">Associated Site</div>
              <div className="site-box">
                {nft.siteName && (
                  <div className="site-row"><span className="label">Name:</span><span className="value">{nft.siteName}</span></div>
                )}
                {nft.siteURL && (
                  <div className="site-row">
                    <span className="label">URL:</span>
                    <a href={nft.siteURL} target="_blank" rel="noopener noreferrer" className="link">{nft.siteURL}</a>
                  </div>
                )}
              </div>
            </div>
          )}

          {nft.metadata.attributes && nft.metadata.attributes.length > 0 && (
            <div className="section">
              <div className="section-title">Attributes</div>
              <div className="attr-grid">
                {nft.metadata.attributes.map((attr, index) => (
                  <div key={index} className="attr-card">
                    <div className="attr-name">{attr.trait_type}</div>
                    <div className="attr-value">{String(attr.value)}</div>
                    {attr.display_type && <div className="attr-chip">{attr.display_type}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="section">
            <div className="info-grid">
              <div className="info-row"><span className="label">Token ID:</span><span className="value">{nft.tokenId}</span></div>
              {nft.owner && (
                <div className="info-row"><span className="label">Owner:</span><span className="value mono">{nft.owner}</span></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NFTDetailModal;
